
import {
  formatDisplayValue,
  formatCurrency,
  formatInteger,
  formatRate,
  formatMonths,
  formatDate,
  formatNumberTwoDecimal,
  formatNumberTwoDecimalWithRounding,
  notImplemented,
  formatCurrencyTwoDecimal,
  formatDecimalNoDecimal,
  formatNumberOneDecimal,
  formatDscr
} from "./formatters";

const CASH_EQUITY = "40008545-c71f-4531-89f0-f14cf7005c73";
const WEIGHTED_MATURITY = "681d7f31-2e11-11e9-ac70-0242ac140002";
const WEIGHTED_AVERAGE_INTEREST_RATE = "681d7f5d-2e11-11e9-ac70-0242ac140002";
const TOTAL_OUTSTANDING_DEBT = "681d7f8a-2e11-11e9-ac70-0242ac140002";
const UNFUNDED_COMMITTED_DEBT = "681d7fb9-2e11-11e9-ac70-0242ac140002";
const LTV = "681d7fec-2e11-11e9-ac70-0242ac140002";
const DEBT_YIELD = "681d801f-2e11-11e9-ac70-0242ac140002";
const DSCR = "681d8052-2e11-11e9-ac70-0242ac140002";
const FIXED_FLOATING_HEDGED_DEBT_PERCENT = "681d8088-2e11-11e9-ac70-0242ac140002";
const HEDGED_PV01 = "681d80bf-2e11-11e9-ac70-0242ac140002";
const UNHEDGED_PV01 = "681d80fa-2e11-11e9-ac70-0242ac140002";
const NOI = "681d8137-2e11-11e9-ac70-0242ac140002";
const PROPERTY_VALUE = "681d8175-2e11-11e9-ac70-0242ac140002";
const PREPAYMENT = "681d81b6-2e11-11e9-ac70-0242ac140002";
const RSF = "681d81f5-2e11-11e9-ac70-0242ac140002";
const MF_UNITS = "681d8238-2e11-11e9-ac70-0242ac140002";
const DEBT_RSF = "681d827b-2e11-11e9-ac70-0242ac140002";
const DEBT_MF_UNIT = "681d82c1-2e11-11e9-ac70-0242ac140002";
const MAX_RECOURSE = "681d8309-2e11-11e9-ac70-0242ac140002";
const AGGREGATE_EQUITY = "681d8353-2e11-11e9-ac70-0242ac140002";
const PROJECTED_RATE = "681d839d-2e11-11e9-ac70-0242ac140002";
const AVG_EXIT_CAP = "da61c955-5af1-11e9-a9b5-0242ac140002";
const PREPAY_PENALTY_RATIO = "da61c9d8-5af1-11e9-a9b5-0242ac140002";
const AVG_HOLD_PERIOD = "da61c9e8-5af1-11e9-a9b5-0242ac140002";
const SALE_PURCHASE_RATIO = "da61c9f4-5af1-11e9-a9b5-0242ac140002";
const FUND_LIFE = "da61ca03-5af1-11e9-a9b5-0242ac140002";
const SALES_PRICE_FT = "da61ca13-5af1-11e9-a9b5-0242ac140002";
const OCCUPANCY = "ebd65eaf-d3be-4dd0-bce4-dc840ff9bbf9";
const LTV_SUBORDINATE = "910149fa-c9a7-11e9-a4f9-00ff12c3b408";
const DEBT_YIELD_SUBORDINATE = "91014e30-c9a7-11e9-a4f9-00ff12c3b408";
const DSCR_LENDER = "91014e3b-c9a7-11e9-a4f9-00ff12c3b408";
const DSCR_LENDER_SUBORDINATE = "91014e40-c9a7-11e9-a4f9-00ff12c3b408";
const DSCR_ACTUAL = "91014e44-c9a7-11e9-a4f9-00ff12c3b408";
const DSCR_ACTUAL_SUBORDINATE = "91014e49-c9a7-11e9-a4f9-00ff12c3b408";
const NOI_ACTUAL = "91014e4d-c9a7-11e9-a4f9-00ff12c3b408";
const REFI_PROCEEDS = "bc486274-8f9e-11ea-9df5-2c4d543da462";
const REFI_CASH_OUT = "e55f534d-101b-4157-aa27-3f841262ce69";
const ALL_IN_EFFECTIVE_RATE = "35a94c35-bcce-436b-8166-e078139fc8b8";

export default {
  [CASH_EQUITY]: formatCurrency,
  [WEIGHTED_MATURITY]: notImplemented,
  [WEIGHTED_AVERAGE_INTEREST_RATE]: formatRate,
  [TOTAL_OUTSTANDING_DEBT]: formatCurrency,
  [UNFUNDED_COMMITTED_DEBT]: formatCurrency,
  [LTV]: formatRate,
  [DEBT_YIELD]: formatRate,
  [DSCR]: formatDscr,
  [FIXED_FLOATING_HEDGED_DEBT_PERCENT]: formatDisplayValue,
  [HEDGED_PV01]: notImplemented,
  [UNHEDGED_PV01]: notImplemented,
  [NOI]: formatCurrency,
  [PROPERTY_VALUE]: formatCurrency,
  [PREPAYMENT]: formatCurrency,
  [RSF]: formatNumberTwoDecimalWithRounding,
  [MF_UNITS]: formatDecimalNoDecimal,
  [DEBT_RSF]: formatCurrencyTwoDecimal,
  [DEBT_MF_UNIT]: formatCurrency,
  [MAX_RECOURSE]: notImplemented,
  [AGGREGATE_EQUITY]: formatCurrency,
  [PROJECTED_RATE]: formatRate,
  [AVG_EXIT_CAP]: formatRate,
  [PREPAY_PENALTY_RATIO]: notImplemented,
  [AVG_HOLD_PERIOD]: formatNumberOneDecimal,
  [SALE_PURCHASE_RATIO]: formatNumberTwoDecimal,
  [FUND_LIFE]: formatNumberOneDecimal,
  [SALES_PRICE_FT]: formatCurrencyTwoDecimal,
  [OCCUPANCY]: formatRate,
  [LTV_SUBORDINATE]: formatRate,
  [DEBT_YIELD_SUBORDINATE]: formatRate,
  [DSCR_LENDER]: formatDscr,
  [DSCR_LENDER_SUBORDINATE]: formatDscr,
  [DSCR_ACTUAL]: formatDscr,
  [DSCR_ACTUAL_SUBORDINATE]: formatDscr,
  [NOI_ACTUAL]: formatCurrency,
  [REFI_PROCEEDS]: formatCurrency,
  [REFI_CASH_OUT]: formatCurrency,
  [ALL_IN_EFFECTIVE_RATE]: formatRate
};
